export default "__VITE_ASSET__C2UbUTEU__"